const ITEMS = [
  "Limpeza comercial", "Escritórios", "Clínicas e consultórios",
  "Contratos recorrentes", "Faxina residencial", "Limpeza pós-obra", "São Paulo",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-serif-d text-4xl md:text-6xl px-8 whitespace-nowrap ${i % 3 === 1 ? "italic text-[#C59B27]" : "text-[#FAF8F5]"}`}>
          {t}
        </span>
        <svg viewBox="0 0 20 20" className="w-5 h-5 shrink-0" aria-hidden="true">
          <path d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" fill="#C59B27" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="bg-[#0F4C3A] py-8 md:py-10 overflow-hidden relative grain">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
